import React from 'react';
import { FaShieldAlt } from 'react-icons/fa';
import { FiCheck } from 'react-icons/fi';

const EquipmentHealth = () => {
  const checks = [
    "Temperature in safe range",
    "No abnormal fluctuations",
    "Cooling performance optimal",
    "Sensor communication stable"
  ];

  return (
    <div className="w-full max-w-sm bg-white border border-gray-100 rounded-2xl p-5 font-sans shadow-[0_2px_12px_rgba(0,0,0,0.01)] flex flex-col justify-between min-h-[360px] select-none">
      <div>
        {/* Title */}
        <h3 className="text-[15px] font-bold text-gray-800 tracking-tight mb-4">
          Equipment Health
        </h3>

        {/* Hero Alert Badge Row */}
        <div className="flex items-center gap-3.5 mb-6">
          <div className="relative text-emerald-600 shrink-0">
            <FaShieldAlt className="w-12 h-12 fill-current" />
            <div className="absolute inset-0 flex items-center justify-center text-white pb-0.5">
              <FiCheck className="w-4 h-4 stroke-[3.5]" />
            </div>
          </div>
          <div className="space-y-0.5">
            <h4 className="text-[18px] font-extrabold text-emerald-600 leading-none">
              Excellent
            </h4>
            <p className="text-[11px] font-semibold text-gray-400">
              All systems operating normally
            </p>
          </div>
        </div>

        {/* Mini Checklist Points */}
        <div className="space-y-3.5 pl-0.5">
          {checks.map((text, idx) => (
            <div key={idx} className="flex items-center gap-2.5">
              <div className="w-4 h-4 bg-emerald-50 text-emerald-600 rounded-full flex items-center justify-center shrink-0">
                <FiCheck className="w-2.5 h-2.5 stroke-[3]" />
              </div>
              <span className="text-[12px] font-semibold text-gray-600">{text}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Footer Meta Indicator */}
      <div className="flex items-center gap-1.5 text-[11px] font-bold text-gray-400 border-t border-gray-50 pt-4 mt-6">
        <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></span>
        <span>Updated: 18 sec ago</span>
      </div>
    </div>
  );
};

export default EquipmentHealth;
